
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[tenantId]/create",
      function () {
        return require("private-next-pages/[tenantId]/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[tenantId]/create"])
      });
    }
  